var _circle, _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg05(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.1,
    cx: 25,
    cy: 25,
    r: 25,
    fill: "#A9E29E"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_391_462",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 13,
    y: 13,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 13,
    y: 13,
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_391_462)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21 34V32H23V30H17C16.45 30 15.9793 29.8043 15.588 29.413C15.196 29.021 15 28.55 15 28V18C15 17.45 15.196 16.979 15.588 16.587C15.9793 16.1957 16.45 16 17 16H33C33.55 16 34.021 16.1957 34.413 16.587C34.8043 16.979 35 17.45 35 18V28C35 28.55 34.8043 29.021 34.413 29.413C34.021 29.8043 33.55 30 33 30H27V32H29V34H21Z",
    fill: "#A9E29E"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg05);
export default __webpack_public_path__ + "static/media/05.28cd33f67f531e1c0cf41105dee06e44.svg";
export { ForwardRef as ReactComponent };